import React, { Component } from 'react';
import _ from 'lodash';
import { StyledModal } from '../style';
import {
  StyledAlignRight,
  StyledList,
  StyledElements,
  StyledBox,
  StyledRadioButton,
  StyledLabel,
  TitleButton,
  StyledDateSelector,
  StyleInput,
  StyledDateSelectorContainer,
  StyledTwoLevelBreadcrumb,
  StyledFormWrapper,
  StyledCheckbox,
  StyledCheckboxReverse,
  StyledAdviseDate
} from './style';

import { IRPFData, BoxForm } from '.';

import {
  dataSectionIRPFFamilyOpts,
  IRPFDataTxts
} from '../../../../../constants/irpf';

import { getTxtFromBool, getBoolFromTxt } from '../../../../../utils/irpfData';
import { convertDateToBBDDFormat } from '../../../../../utils/dates';
import { validateDNI } from '../../../../../utils/validations';

import Button from '../../../../core/Buttons';

const getFormattedDate = date => {
  const dateFormatted = date;
  const initialHours = date.getHours();

  dateFormatted.setHours(initialHours - 2);
  return dateFormatted;
};

class IRPFForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataForm: _.cloneDeep(props.initialData),
      validConyugeNif: true,
      disabledBtn: true,
      disabledDate: !props.initialData.dateGeographicalMobility,
      onErrorDate: false,
      currentDateSelected: props.initialData.dateGeographicalMobility
        ? getFormattedDate(new Date(props.initialData.dateGeographicalMobility))
        : getFormattedDate(new Date()),
      isCancelling: false
    };
  }

  changeForm = (value, key) => {
    const { initialData } = this.props;
    const { dataForm, disabledDate } = this.state;
    let isDisabledDate;

    if (key === 'dateGeographicalMobility') {
      isDisabledDate = !value;

      dataForm[key] = value ? convertDateToBBDDFormat(value) : value;

      if (!value && !('dateGeographicalMobility' in initialData)) {
        delete dataForm[key];
      }
    } else {
      dataForm[key] = value;
    }

    const dataHasNotChanged = _.isEqual(initialData, dataForm);

    this.setState({
      dataForm,
      disabledDate:
        isDisabledDate !== undefined ? isDisabledDate : disabledDate,
      disabledBtn: dataHasNotChanged
    });
  };

  handleOnSend = () => {
    const { onSend } = this.props;
    const { dataForm } = this.state;

    if (
      dataForm.civilStatus === 'MARRIED' &&
      !validateDNI(dataForm.spouseNif)
    ) {
      this.setState({
        validConyugeNif: false
      });
    } else {
      const dataFormFormatted = Object.entries(dataForm).reduce((acc, next) => {
        const [key, value] = next;
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      onSend(dataFormFormatted);
    }
  };

  handleCancel = () => {
    this.setState({
      isCancelling: true
    });
  };

  render() {
    const {
      dataForm,
      currentDateSelected,
      disabledBtn,
      validConyugeNif,
      isCancelling,
      onErrorDate,
      disabledDate
    } = this.state;

    return (
      <IRPFData>
        <StyledFormWrapper>
          <StyledTwoLevelBreadcrumb
            first={IRPFDataTxts.breadcrumb.first}
            second={IRPFDataTxts.breadcrumb.second}
            onBack={() => {
              this.setState({
                isCancelling: true
              });
            }}
          />
          <StyledBox>
            <TitleButton>
              {dataSectionIRPFFamilyOpts.situacionFamiliar.title}
            </TitleButton>
            <StyledList>
              <StyledElements>
                <BoxForm>
                  <StyledRadioButton
                    label={
                      dataSectionIRPFFamilyOpts.situacionFamiliar.sections
                        .options.single.textLong
                    }
                    name="situacionFamiliar"
                    value="Soltero/a"
                    checked={
                      dataForm.civilStatus ===
                      'SINGLE_SEPARATED_DIVORCED_WIDOWED'
                    }
                    onChange={() =>
                      this.changeForm(
                        'SINGLE_SEPARATED_DIVORCED_WIDOWED',
                        'civilStatus'
                      )
                    }
                  />
                </BoxForm>
              </StyledElements>
              <StyledElements>
                <BoxForm>
                  <StyledRadioButton
                    label={
                      dataSectionIRPFFamilyOpts.situacionFamiliar.sections
                        .options.married.textLong
                    }
                    name="situacionFamiliar"
                    value="Casado/a"
                    checked={dataForm.civilStatus === 'MARRIED'}
                    onChange={() => this.changeForm('MARRIED', 'civilStatus')}
                  />
                </BoxForm>
              </StyledElements>
              <StyledElements>
                <BoxForm>
                  <StyledLabel
                    label={dataSectionIRPFFamilyOpts.conyuge.textLong}
                    htmlFor="conyuge_nif"
                  />
                  <StyleInput
                    id="conyuge_nif"
                    name="conyuge_nif"
                    disabled={dataForm.civilStatus !== 'MARRIED'}
                    value={dataForm.spouseNif}
                    error={
                      !validConyugeNif ? 'Introduce un NIF correcto' : false
                    }
                    onChange={value => this.changeForm(value, 'spouseNif')}
                  />
                </BoxForm>
              </StyledElements>
              <StyledElements>
                <BoxForm>
                  <StyledRadioButton
                    label={
                      dataSectionIRPFFamilyOpts.situacionFamiliar.sections
                        .options.others.textLong
                    }
                    name="situacionFamiliar"
                    value="OTHERS"
                    checked={dataForm.civilStatus === 'OTHERS'}
                    onChange={() => this.changeForm('OTHERS', 'civilStatus')}
                  />
                </BoxForm>
              </StyledElements>
            </StyledList>
          </StyledBox>
          <StyledBox>
            <TitleButton>
              {dataSectionIRPFFamilyOpts.movilidadGeografica.title}
            </TitleButton>
            <StyledList>
              <StyledElements>
                <BoxForm>
                  <StyledCheckbox
                    label={
                      dataSectionIRPFFamilyOpts.movilidadGeografica.textLong
                    }
                    htmlFor="fecha_traslado"
                    onChange={value => {
                      this.changeForm(
                        value ? currentDateSelected : null,
                        'dateGeographicalMobility'
                      );
                    }}
                    checked={!disabledDate}
                  />
                  <StyledLabel />
                  <StyledDateSelectorContainer>
                    <StyledAdviseDate disabledDate={disabledDate}>
                      Indique la fecha de dicho traslado
                    </StyledAdviseDate>
                    <StyledDateSelector
                      onChange={value => {
                        this.setState({ currentDateSelected: value });
                        this.changeForm(value, 'dateGeographicalMobility');
                      }}
                      years={50}
                      date={currentDateSelected}
                      error={onErrorDate ? 'Introduce una fecha valida' : false}
                      disabled={disabledDate}
                    />
                  </StyledDateSelectorContainer>
                </BoxForm>
              </StyledElements>
            </StyledList>
          </StyledBox>
          <StyledBox>
            <TitleButton>
              {dataSectionIRPFFamilyOpts.prolongacionActividad.title}
            </TitleButton>
            <StyledList>
              <StyledElements>
                <BoxForm>
                  <StyledCheckboxReverse
                    label={
                      dataSectionIRPFFamilyOpts.prolongacionActividad.textLong
                    }
                    onChange={value =>
                      this.changeForm(getTxtFromBool(value), 'workLonger')
                    }
                    checked={getBoolFromTxt(dataForm.workLonger)}
                  />
                </BoxForm>
              </StyledElements>
            </StyledList>
          </StyledBox>
          <StyledBox>
            <TitleButton>
              {dataSectionIRPFFamilyOpts.vivienda.title}
            </TitleButton>
            <StyledList>
              <StyledElements>
                <BoxForm>
                  <StyledCheckboxReverse
                    label={dataSectionIRPFFamilyOpts.vivienda.textLong}
                    onChange={value =>
                      this.changeForm(
                        getTxtFromBool(value),
                        'purchaseRenovationMainResidence'
                      )
                    }
                    checked={getBoolFromTxt(
                      dataForm.purchaseRenovationMainResidence
                    )}
                    reverse
                  />
                </BoxForm>
              </StyledElements>
            </StyledList>
          </StyledBox>
          <StyledAlignRight>
            <Button dark ghost onClick={() => this.handleCancel()}>
              CANCELAR
            </Button>
            <Button
              secondary
              onClick={() => this.handleOnSend()}
              disabled={disabledBtn}
            >
              ENVIAR SOLICITUD
            </Button>
          </StyledAlignRight>
          {isCancelling && (
            <StyledModal
              title="CANCELAR SOLICITUD"
              clickCloseIcon={() => this.setState({ isCancelling: false })}
            >
              <p>¿Seguro que quieres cancelar la solicitud?</p>
              <Button
                modal
                onClick={() => this.setState({ isCancelling: false })}
              >
                Seguir editando
              </Button>
              <Button secondary onClick={() => this.props.onCancel()}>
                Cancelar
              </Button>
            </StyledModal>
          )}
        </StyledFormWrapper>
      </IRPFData>
    );
  }
}

export { IRPFForm };
